// extracted by mini-css-extract-plugin
export default {"item":"ParticipantInput_item__QF7vR","highlighted":"ParticipantInput_highlighted__fUWXi","details":"ParticipantInput_details__biS0g","name":"ParticipantInput_name__+Joqt"};